import { DataSource, Layout, Panel, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffRegionLocationSlideOut extends Layout {
    panelTariffLocation: Panel;
    sourceTariffRegionLoc: DataSource;
    textboxCityName: Textbox;
    textboxEffectiveDate: Textbox;
    textboxExpirationDate: Textbox;
    textboxLocationId: Textbox;
    textboxLocationName: Textbox;
    textboxState: Textbox;
    textboxZipCode: Textbox;
    textboxaddress: Textbox;
}
